let socioeconomicFactorRadius = function (socioeconomicScore = 0) {
  let parsed = parseFloat(socioeconomicScore);
  // Siplified version of (parsed / 5) * 50 * 1.2 + 10;
  let score = parsed * 12 + 10;

  if (parsed === 0) {
    return 0;
  }

  if (score >= 70) {
    return 70;
  }

  return score;
};

export { socioeconomicFactorRadius };
